export default {
    name: 'safeStartPlanSignature',
    miniSave: true,
    uploadFunction: ({ requestFunction, data, saveId }) => {
        return requestFunction
            .methodRequest(`/crewconfig/safestartplan/${data.crewid}/${data.safestartplanid}`, 'POST', data)
    },
    restoreSave: (ctx) => {
    }
}